export default function getFormatedDateTime(datetime: string): string {
  const datetime_parts = datetime.split(' ');
  const date_parts = datetime_parts[0].split('-');
  const time_parts = datetime_parts[1].split(':');
  return `${date_parts[2]}/${date_parts[1]}/${date_parts[0]} ${time_parts[0]}h${time_parts[1]}min`;
}
